import Ajax from "../Ajax";
import { Alert, AlertModal } from "..";
import { store } from "../stores/Store";
import { observer } from "mobx-react-lite";
import IsAllowed from "../models/Permissions";
import InlineMenu, { InlineMenuItem } from "./InlineMenu";
import DeleteForm from "../components/form/case/DeleteForm";
import { UserUpdateForm } from "../components/form/admin/UserForms";
import { CaseCreateForm, CaseEditForm } from "../components/form/case/CaseForms";
import UpdatePasswordForm from "../components/form/admin/UserPasswordUpdateForm";
import EnquiryUpdateSectionForm from "../components/form/enquiry/EnquiryUpdateSectionForm";
import NodeMoveForm from "../components/form/NodeMoveForm";
import { FolderCreateForm, FolderEditForm } from "../components/form/folder/FolderForms";
import { AccountEditForm } from "../components/form/admin/AccountForms";
import AutomationNodeCreateForm from "../components/form/automation/AutomationNodeCreateForm";


interface NodeOptionsMenuProps {
    node: any;
    disabled?: boolean;
}


export default observer(function NodeMenus ({node, disabled = false}: NodeOptionsMenuProps) {

    // if (store.AppStore.checkJwtRoles(["client_account", "sponsor_account"], false)) return <></>

    if (!node) {
        return <InlineMenu disabled={true} menuItems={[]} />
    }

    return (
        <InlineMenu
            disabled={!!store.AppStore.sessionState || disabled}
            title={store.NodeStore.getDisplayType(node) + " options"}
            menuItems={NodeOptionsMenuItems(node)} />
    )
})


const NodeOptionsMenuItems = (node): InlineMenuItem[] => {

    const {ReportStore, NodeStore, AppStore} = store

    const handleSuccess = (navigateNodeUid = null) => {
        store.AlertStore.Close()
        if (navigateNodeUid) {
            NodeStore.navigateNode(navigateNodeUid)
        }
        else {
            NodeStore.refreshFolderNode()
        }
    }

    if (AppStore.readOnly) return []

    switch (node.typeName) {
        case "Aora.Platform.Data.AccountNode":
        case "Aora.Nationality.Data.SponsorAccountNode":

            return [
                {
                    // label: node.typeName === "Aora.Nationality.Data.SponsorAccountNode" ? "Create Skilled Worker Visa case" : "Create nationality case",
                    label: `Create Case for ${node.label}`,
                    action: () => {
                        const guidance = node.typeName === "Aora.Nationality.Data.SponsorAccountNode"
                            ? `This Case will be associated with ${node.label}, Skilled Worker enquiries will be available.`
                            : "This Case won't be associated with a Sponsor Client so skilled worker enquiries will not be possible."
                        AlertModal({body: <CaseCreateForm parentUid={node.uid} guidance={guidance} onSuccess={(node) => handleSuccess(node?.uid)} />})
                    }
                },
                {
                    label: `Edit info for ${node.label}`,                   
                    action: async () => {
                        await Ajax.Node.Get(node.uid).then((response) => {
                            var nodeType = store.NodeStore.getDisplayType(node)
                            AlertModal({title: `Edit ${nodeType}`, body: (
                                <AccountEditForm
                                    account={response.data}
                                    onSuccess={() => {
                                        handleSuccess()
                                        store.NodeStore.getAccounts()
                                    }}
                                />
                            )})
                        })
                }},
                {label: "Create Folder",                action: () => AlertModal({body: <FolderCreateForm parentUid={node.uid} onSuccess={(node) => handleSuccess(node?.uid)} />}) },
                {label: "Create Case",                  action: () => AlertModal({body: <CaseCreateForm parentUid={node.uid} onSuccess={(node) => handleSuccess(node?.uid)} />}) },
                {label: "Refresh",                      action: () => NodeStore.refreshFolderNode()}
            ]
        case "Aora.Platform.Data.UserNode":
            return [
                {label: "Change password",              action: () => AlertModal({body: <UpdatePasswordForm user={node} />, size: "xs"})},
                {label: "Edit user",                    action: () => AlertModal({body: <UserUpdateForm user={node} onSuccess={() => store.AlertStore.Close()} requestFullUser />}),   hidden: IsAllowed(node, "UPDATE")},
            ]
        case "Aora.Platform.Data.FolderNode":

            return [
                // {label: "Edit Folder",                  action: () => AlertModal({body: <FolderEditForm folderNode={node} onSuccess={() => handleSuccess()} />}) },
                {label: "Move Folder",                  action: () => AlertModal({body: <NodeMoveForm accountUid={node.account.uid} node={node} />, width: "600px"})},
                {label: "Delete Folder",                action: () => AlertModal({body: <DeleteForm node={node} />, width: "500px"}), hidden: !IsAllowed(node, "DELETE")},
                {label: "Create Subfolder",             action: () => AlertModal({body: <FolderCreateForm parentUid={node.uid} onSuccess={(node) => handleSuccess(node?.uid)} />}) },
                {label: "Create Case",                  action: () => AlertModal({body: <CaseCreateForm parentUid={node.uid} onSuccess={() => handleSuccess()} />}) },
                {label: "Refresh",                      action: () => NodeStore.refreshFolderNode()}
            ]

        case "Aora.Nationality.Data.SponsorNode":
            return [
                {label: "Edit Sponsor",                 action: () => { NodeStore.isEditing = true }}
            ]

        case "Aora.Platform.Data.CaseNode":

            var accountUid = null

            if (NodeStore.folderNode.uid.includes("ACCOUNT")) {
                accountUid = NodeStore.folderNode?.uid
            } else if (NodeStore.folderNode.uid.includes("FOLDER")) {
                accountUid = NodeStore.folderNode?.account?.uid
            }

            var isSwvCase = (
                NodeStore.folderNode?.uid === node.uid &&
                !!NodeStore.folderNode?.childrenObjects?.find(cn => cn.uid.includes("SPONSOR"))
            )

            return [
                {label: "Create Person",                action: () => store.QuestionStore.initForm("CREATE_PERSON"), hidden: node.uid !== store.NodeStore.folderNode?.uid},
                {label: "Create Standalone Application", action: () => {
                    AlertModal({title: "Create Standalone Application", width: "600px", body: (
                        <AutomationNodeCreateForm caseUid={node.uid} />
                    )})
                }, hidden: !isSwvCase || !store.AppStore.sessionInfo.assessmentSkipEnabled},
                {label: "Edit Case",                    action: () => AlertModal({body: <CaseEditForm caseNode={node} onSuccess={() => store.AlertStore.Close()} />}) },
                {label: "Move Case",                    action: () => AlertModal({body: <NodeMoveForm accountUid={accountUid} node={node} />, width: "600px"}), hidden: !accountUid},
                {label: "Delete Case",                  action: () => AlertModal({body: <DeleteForm node={node} />, width: "500px"}), hidden: !IsAllowed(node, "DELETE")},
                {label: "Refresh",                      action: () => NodeStore.refreshFolderNode()}
            ]

        case "Aora.Nationality.Data.PersonNode":
            return [
                {label: "Edit person",                  action: () => { store.NodeStore.isEditing = true }},
            ]

        case "Aora.Platform.Data.EnquiryNode":

            var settingsSection = node.childrenObjects.find(s => s.name === "SETTINGS")
        
            return [
                {label: "Re-run",                               action: () => Ajax.Enquiry.Rerun(node.uid).catch(response => Alert({message: response?.data?.detail})), hidden: !store.AppStore.checkJwtRole("sysuser")},
                {label: "Enquiry settings",                     action: () => AlertModal({title: "Update settings", width: "600px", body: <EnquiryUpdateSectionForm enquiryUid={node.uid} section={settingsSection} />})},
            ]

        case "Aora.Platform.Data.ReportNode":
            return [
                {label: "Download",         action: () => ReportStore.download(node),       disabled: ["R", "F"].includes(node.fileStatus)}, // Disabled if "Requested" or "Failed"
                {label: "Regenerate",       action: () => ReportStore.regenerate(node),     hidden: !IsAllowed("ReportNode", "UPDATE") },
                {label: "Mark as invalid",  action: () => ReportStore.makeInvalid(node),    hidden: !IsAllowed("ReportNode", "UPDATE") },
            ]

        default:
            return [
                // {label: "No options",       action: () => {}, disabled: true},
                {label: "Refresh",          action: () => NodeStore.refreshFolderNode()}
            ]
    }
}